import { useEffect, useState } from 'react';

/**
 * 초기 로딩 상태 관리 훅
 * - 최소 표시 시간(delay ms) 이상 로딩 화면을 유지
 * - loading이 false가 된 후에도 delay가 경과해야 로딩 해제
 */
export const useInitialLoadingState = (loading: boolean, delay = 1500): boolean => {
    const [timerElapsed, setTimerElapsed] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setTimerElapsed(true), delay);
        return () => clearTimeout(timer);
    }, [delay]);

    useEffect(() => {
        if (!loading) setDataLoaded(true);
    }, [loading]);

    return !timerElapsed || !dataLoaded;
};
